import React, { useState, useEffect, useCallback } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import useInput from "../../../hooks/useInput";
import { useAppDispatch } from "../../../store";
import { Navigate, useNavigate,useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducer/index";
import * as styles from "../../../styles/DiaryPage";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Calendar, DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { SelectOptionType } from "../../../FrontType/index";
import userSlice from "../../../reducer/user";
import { LoadFarm, LoadmultidiaryList } from "../../../reduxaction/post";
import postSlice from "../../../reducer/post";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import SelectDiaryList from "./component/SelectDiaryList";
import axios from "axios";
dayjs.locale("ko");

const DiaryPage = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const { Targetfarms, MultiDiarylist } = useSelector(
		(state: RootState) => state.post
	);
	const { me } = useSelector((state: RootState) => state.user);

	const [values, setValues] = useState<any>([]);
	const [selected, setSelected] = useState<SelectOptionType[]>([]);

	const location = useLocation();
	
	useEffect(() => {
		dispatch(userSlice.actions.Routerpath("/DiaryPage"));
	}, []);

	useEffect(() => {
		dispatch(LoadFarm());
	}, [dispatch, me]);

	const times = values.map((time: any) => {
		return {
			year: time.year,
			month: time.month.number,
			day: time.day,
		};
	});

	// const insects = Targetfarms
	// 	? Targetfarms.children.map((place) => {
	//       return {
	//         // label: place.productCodeInfo.name,
	// 				// value: place.productCodeInfo.code,
	// 				label: place.name,
	// 				value: place.productCode,
	//       };
	//     })
	//   : [];
		
	const [isArrow, setIsArrow] = useState<string>("");
  const [id1, setId1] = useState<string>("");
  const [id2, setId2] = useState<string>("");
  const [id3, setId3] = useState<string>("");
	const [id4, setId4] = useState<string>("");
	const [id5, setId5] = useState<string>("");
	const [id6, setId6] = useState<string>("");
	const [id7, setId7] = useState<string>("");
	const [backYn, setBackYn] = useState<boolean>(false);
	const [currentDate, setCurrentDate] = useState<number>(0);
	
	const [insects, setInsects] = useState<SelectOptionType[]>([]);
	const getInsects = async () => {
		try {
			const response = await axios.get(`ifactory/api/productcode`);
//			console.log("response : ", response);

			return response.data.map((insect: any) => {
				return {
					label: insect.productName,
					value: insect.productCode,
				};
			});
		} catch (error: any) {
			console.error(error);
		}
	};
	
	useEffect(() => {
		getInsects().then((data) => {
			setInsects(data);

		if (location.search || (location.state != null && location.state.isArrow)) { 
			
			let let_isArrow = location.state != null ? location.state.isArrow : location.search.split("&")[0].split("=")[1] ;
			let let_id1 = location.state != null ? location.state.id1 : location.search.split("&")[1].split("=")[1] ;
			let let_id2 = location.state != null ? location.state.id2 : location.search.split("&")[2].split("=")[1] ;
			let let_id3 = location.state != null ? location.state.id3 : location.search.split("&")[3].split("=")[1] ;
			let let_id4 = location.state != null ? location.state.id4 : location.search.split("&")[4].split("=")[1] ;
			let let_id5 = location.state != null ? location.state.id5 : location.search.split("&")[5].split("=")[1] ;
			let let_id6 = location.state != null ? location.state.id6 : location.search.split("&")[6].split("=")[1] ;
			let let_id7 = location.state != null ? location.state.id7 : location.search.split("&")[7].split("=")[1] ;

			if (let_isArrow !== "" && let_isArrow !== undefined) setIsArrow(let_isArrow);
			if (let_id1 !== "" && let_id1 !== undefined) setId1(let_id1);
			if (let_id2 !== "" && let_id2 !== undefined) setId2(let_id2);
			if (let_id3 !== "" && let_id3 !== undefined) setId3(let_id3);
			if (let_id4 !== "" && let_id4 !== undefined) setId4(let_id4);
			if (let_id5 !== "" && let_id5 !== undefined) setId5(let_id5);

			if (let_id6 !== "" && let_id6 !== undefined) {
				setId6(let_id6);

				let chSelect = data.filter((v:any) => let_id6.includes(v.value));
				if (data.length === chSelect.length) {
					setAllChecked(true);
					chSelect.unshift({ label: "전체", value: "WHOLE" });
				}
				setSelected(chSelect);
			}


			if (let_id7 !== "" && let_id7 !== undefined) {
				setId7(let_id7);
				setValues(let_id7.split(",").map((v: any) => new DateObject().setDate(v)));
				setCurrentDate(let_id7.split(",")[0]);
			}

			if (let_id7 !== "" && let_id7 !== undefined && let_id6 !== "" && let_id6 !== undefined) setBackYn(true);
		}

		});
	}, []);

	useEffect(() => {

		if (backYn)
		{
			postfunc();
			setBackYn(false);			
		}
	}, [backYn]);

  // 중복 제거
  const result: SelectOptionType[] = insects.filter(
    (v: any, i: number) => insects.findIndex((x) => x.label === v.label) === i
  );
  result.unshift({ label: "전체", value: "WHOLE" });


	// 전체 선택 체크박스
	const [allChecked, setAllChecked] = useState(false);

	// '전체' 체크박스가 선택되면 allChecked를 true로 설정하고, 그렇지 않으면 false로 설정합니다.
	const handleAllChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
		setAllChecked(event.target.checked);
		if (event.target.checked) {
			setSelected(result.map((insect) => ({ ...insect })));
		} else {
			setSelected([]);
		}
	};

  // 곤충 선택 코드
	const selectfunc = (insect: SelectOptionType) => {
		const newSelected = [...selected];
		const hasSelected = newSelected.find((v) => v.value === insect.value);
	
		if (hasSelected) {
			const filterData = newSelected.filter((v) => v.value !== hasSelected.value);
			setSelected(filterData);
		} else {
			newSelected.push(insect);
			setSelected(newSelected);
		}
	
		if (allChecked && insect.value !== 'WHOLE') {
			setAllChecked(false);
			setSelected(selected.filter(item => item.value !== 'WHOLE'));
		}
  };

  useEffect(() => {
    dispatch(postSlice.actions.refreshMultiDiarylist());
  }, [values]);

  const postfunc = useCallback(async () => {
    if (times.length < 1) {
			setId7("");
      return confirmAlert({
        title: "날짜를 선택해 주세요.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }

    if (selected.length < 1) {
			setId6("");
      return confirmAlert({
        title: "곤충을 선택해 주세요.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }

    dispatch(postSlice.actions.refreshMultiDiarylist());

    let timeseperate = "";
    times.map((v: any) => {
      timeseperate += `${v.year}-${v.month < 10 ? "0" : ""}${v.month}-${
        v.day < 10 ? "0" : ""
      }${v.day},`;
    });

    timeseperate = timeseperate.slice(0, -1);

    if (values.length >= 5) {
      return confirmAlert({
        title: "최대 4일까지만 선택 가능합니다.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }
    const haswhole = selected.find((v) => v.value === "WHOLE");
		if (haswhole) {
			setId6(selected.filter((v) => v.value !== "WHOLE").map((v) => v.value).join(","));
			setId7(timeseperate);
      let response = await dispatch(
        LoadmultidiaryList(
          `farmId=${Targetfarms?.placeId}&page=${0}&size=10000&productCodes=${
					// haswhole.value
					selected.filter((v) => v.value !== "WHOLE").map((v) => v.value).join(",")
          }&selectDate=${timeseperate}`
        )
			);
			const response1 = await dispatch(
        LoadmultidiaryList(
          `farmId=${Targetfarms?.placeId}&page=${1}&size=10000&productCodes=${
					// haswhole.value
					selected.filter((v) => v.value !== "WHOLE").map((v) => v.value).join(",")
          }&selectDate=${timeseperate}`
        )
			);
			if (response1.payload.length > 0) {
				response = await dispatch(
					LoadmultidiaryList(
						`farmId=${Targetfarms?.placeId}&page=${0}&size=20000&productCodes=${
						// haswhole.value
						selected.filter((v) => v.value !== "WHOLE").map((v) => v.value).join(",")
						}&selectDate=${timeseperate}`
					)
				);
			}

      if (response.payload.length < 1) {
				console.log('test1');
        return confirmAlert({
          title: "선택하신 날짜에 데이터가 없습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }

      // );
		} else {
      const hasNotwhole = selected.filter((v) => v.value !== "WHOLE");

      let data = "";

      hasNotwhole.forEach((v) => {
        data += `${v.value},`;
      });
      data = data.slice(0, -1);
			setId6(data);
			setId7(timeseperate);

      let response = await dispatch(
        LoadmultidiaryList(
          `farmId=${Targetfarms?.placeId}&page=${0}&size=10000&productCodes=${data}&selectDate=${timeseperate}`
        )
			);
			
      let response1 = await dispatch(
        LoadmultidiaryList(
          `farmId=${Targetfarms?.placeId}&page=${1}&size=10000&productCodes=${data}&selectDate=${timeseperate}`
        )
      );

			if (response1.payload.length > 0) {
        LoadmultidiaryList(
          `farmId=${Targetfarms?.placeId}&page=${0}&size=20000&productCodes=${data}&selectDate=${timeseperate}`
        )
			}

      if (response.payload.length < 1) {
				console.log('test');
        return confirmAlert({
          title: "선택하신 날짜에 데이터가 없습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }
    }
  }, [selected, values, times]);

  let result2 = times.map((time: any) => {
    return {
      diaries: MultiDiarylist.filter((diary) => {
        let tagStdDate = new Date(diary.tagStdDate);

        return (
          tagStdDate.getFullYear() === time.year &&
          tagStdDate.getMonth() + 1 === time.month &&
          tagStdDate.getDate() === time.day
        );
      }),

      diaryTime: time,
    }; // 걸러진 애들이 배열로 반환
  });
  //[[25일애들], [26일애들], [27일배열] ]

  useEffect(() => {
    if (values.length >= 5) {
      const h = [...values];
      h.pop();
      setValues([...h]);
      return confirmAlert({
        title: "최대 4일까지만 선택할 수 있습니다.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }
	}, [values]);

  return (
    <styles.Container>
      <styles.PageTop>
				<p className="pagetit">사육일지</p>
        <p className="move-btn">
          <img
            src="./img/X.svg"
            onClick={() => {
							// navigate(-1);
							 navigate("/MainPage", {
								 state: {
									 isArrow: isArrow,
									 id1: id1,
									 id2: id2,
									 id3: id3,
									 id4: id4,
									 id5: id5
								 }
							 });
						 }}
            alt="X"
          />
        </p>
      </styles.PageTop>
			<styles.Calendar>
			
				<Calendar
						className="multi-locale-days"
						multiple
						value={values}
						format="YYYY-MM-DD"
					sort
					onChange={setValues}
						plugins={[<DatePanel key="datePanel" position="bottom" />]}
					/>
      </styles.Calendar>

      <styles.InsectSelect>
        <p className="content-tit">곤충선택</p>
        <styles.CheckBox>
          {result.map((insect, index) => {
            return (
							<div key={ index }>
                <input
									type="checkbox"
                  id={`${insect.label}`}
                  name={`${insect.label}`}
                  value={`${insect.value}`}
									checked={selected.some(el => el.value === insect.value)}
        					onChange={insect.value === "WHOLE" ? handleAllChecked : () => selectfunc(insect)}
								/>
								<label htmlFor={insect.label} key={index}>{insect.label}</label>
							</div>
            );
          })}
        </styles.CheckBox>

        <styles.ButtonCon>
					<div onClick={postfunc}>검색</div>
				</styles.ButtonCon>
      </styles.InsectSelect>

      {result2.map((diary: any, index:number) => {
				return <SelectDiaryList diary={diary} key={ index }  params={{"isArrow":isArrow,"id1":id1,"id2":id2,"id3":id3,"id4":id4,"id5":id5,"id6":id6,"id7":id7}} />;
      })}
    </styles.Container>
  );
};

export default DiaryPage;
